import { render, staticRenderFns } from "./EsgBaseCard.vue?vue&type=template&id=462b4332&scoped=true"
import script from "./EsgBaseCard.vue?vue&type=script&lang=js"
export * from "./EsgBaseCard.vue?vue&type=script&lang=js"
import style0 from "./EsgBaseCard.vue?vue&type=style&index=0&id=462b4332&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462b4332",
  null
  
)

export default component.exports